const Form101TC = {
    stepName: {
        importantNotes: "重要事項",
        post: "申請職位",
        personalParticulars: "個人資料",
        educationQualifications: "就學詳情及相關學歷",
        bachelorAndMaster: "學士及碩士學位",
        teacherTraining: "教師培訓及專業資格",
        languageProficiency: "語文能力及其他測試",
        supplementaryInformation: "補充資料 (適用於特定職位)",
        workingExperience: "工作經驗",
        otherInformation: "其他資料 (可選擇是否填寫)",
        supportingDocument: "證明文件",
        declaration: "聲明",
        confirmation: "確認",
    },
    importantNotes: {
        title: "申請人須知",
        title1: "一般注意事項",
        title2: "填交申請時的注意事項",
        title3: "遞交申請後的注意事項",
        title4: "查詢",
    },
    importantNotesStep: [
        {
            textBefore: "使用本系統進行網上申請時，請先參閱「",
            text: "電腦系統配置",
            textAfter: "」有關系統及電腦配置的要求。",
        },
        {
            text: "教育局會在你成功遞交整份網上申請書、更改申請資料或遞交補充資料後<b>2小時內</b>以電郵確認你遞交的資料已獲受理。為確保申請書及確認通知傳遞無誤，你<b>必須</b>於網上申請書內填寫<b>正確</b>的電郵地址。你在此後不能在網上更改電郵地址。",
        },
        {
            text: "你只會在遞交整份網上申請書後才獲發網上參考編號。日後與教育局聘用及人事組聯絡時，請引述你的網上參考編號。",
        },
        {
            text: "你必須填報申請書內要求提供的所有個人資料，但註明是可選擇是否填報的資料則屬例外。教育局可能要求你就特定項目提供詳細資料，以支持申請個別職位。你必須參閱招聘廣告內列出的有關要求填寫本申請書。如你未能提供所要求的所有資料，或所提供的資料未能清楚顯示你具備有關職位所規定最起碼的學歷、訓練、經驗或其他條件，<u>申請書將不獲受理</u>。",
        },
        {
            text: "你在本申請書內所提供的個人資料，將用於招聘工作，以及其他與僱用和人力資源管理有關的事宜上。如有需要，有關資料可能會送交獲授權處理有關資料的政府部門及其他組織或機構，用以進行與政府招聘工作及僱用有關的事宜，例如學歷評審、體格檢查、僱主推薦及操守審查等。在一般情況下，未獲取錄申請人的個人資料，教育局將於其落選日期後24個月全部銷毀。",
        },
        {
            text: "你可以一份網上申請書申請多份教育局同時招聘的職位空缺。",
        },
        {
            text: "如你持有學府或專業團體所頒授的學歷及／或專業資格，請於填妥網上申請表後，在教育局規定的截止申請日期或之前向教育局上載相關文憑／證書、成績單及列明有關資歷的授課形式（例如全日制／兼讀制、在當地院校授課／遙距授課等）的證明文件副本。為了方便進行學歷評審的工作，如你在取得上述的資歷前已獲取其他資歷，亦應盡可能就該等其他資歷提供證明文件副本。",
        },
        {
            text: "如你未能在進入系統後<b>2小時內</b>完成整份申請書，可按系統內的「儲存」鍵，把已填寫的部分存檔。日後當你以電郵地址或「智方便」登入系統後，然後上載有關資料到表格內繼續申請。申請人往後不能更改連結存檔的電郵地址。",
        },
        {
            text: "你可於職位<b>截止申請日期或之前</b>，使用你的電郵地址或「智方便」登入系統，以查詢或更改你在申請書內所提交的資料，或遞交補充資料。",
        },
        {
            text: "當申請人在步驟8按「下一步」後，系統會把你遞交的資料再度顯示在螢幕上。請覆核資料及列印一份作個人參考，其後請再按「遞交」，以完成申請程序。",
        },
        {
            text: "職位截止申請後，有關的網上招聘廣告將被移除。請保留你所申請每份職位的招聘廣告副本一份，以備日後參考。",
        },
        {
            text: "教育局可能會以你於申請書中所提供的電郵地址作聯絡之用及／或（如認為合適）向該電郵地址發出聘書。你應經常及定期查閱你的電郵帳戶（包括垃圾郵件箱、群發郵件箱及雜件郵箱）。如你未能及時依照教育局發出的電郵指示行事，你的申請書將不獲受理或任何已發出的聘書將自動失效。",
        },
        {
            text: "如有以下情況，請與教育局聘用及人事組聯絡：",
        },
    ],
    contactEDBInfo: {
        info1: "未有在遞交整份網上申請書後2小時內接獲確認申請通知的電郵；",
        info2: "遞交網上申請書後，本申請書內所提供的資料（包括你的香港特別行政區永久性居民的身分）有任何更改；",
        info3: "遞交申請書後，你需要更改或查詢個人資料；或",
        info4: "查詢與招聘有關的事宜。",
    },
    contactInfo: {
        title: "<sup>♯</sup>教育局聘用及人事組聯絡資料如下:",
        post: "<u>申請職位</u>",
        tel: "<u>聯絡電話</u>",
        postOne:
            "助理教育主任(行政)／一級專責教育主任／二級專責教育主任／言語治療主任",
        telOne: "2892 6177",
        postTwo: "",
        postThree: "助理督學（學位）",
        telThree: "2892 6175",
        postFour: "助理教育主任",
        telFour: "2892 5958",
        postFive: "助理小學學位教師",
        telFive: "2892 5978",
    },
    label: {
        addJob: "增加職位",
        jobPeriodStart: "開始時間",
        jobPeriodEnd: "結束時間",
        jobTitle: "職位",
        publish: "發佈",
        subject: "科目",
        english: "Eng(LPA)",
        otherEnglish: "Eng(Others)",
        math: "Maths",
        putonghua: "PTH(LPA)",
        supplementary: "補充資料",
        dailyStatistics: "Daily Statistics for Reviewers",
        name: "姓名",
        userName: "用户名稱",
        email: "電郵地址",
        title: "稱謂",
        englishSurname: "英文姓名（姓氏）",
        englishOtherName: "英文姓名（名字）",
        chineseName: "中文姓名",
        chineseNameCode: "中文姓名電碼",
        dateBirth: "出生日期",
        sexCode: "性別",
        hkidCardNo: "香港身份證號碼",
        hkCardNumText: "（本欄供沒有香港身份證的申請人塡寫）",
        passport: "護照/ 旅行證件號碼",
        issuingAuthority: "簽發機關",
        permanentResident: "你是否香港特別行政區永久性居民?",
        residentialAddress: "住址",
        Room: "單位/室",
        Floor: "樓層",
        Block: "座/大廈",
        Estate: "屋邨",
        Road: "道/街",
        District: "分區",
        Country: "國家 / 地區",
        correspondenceAddress: "通訊地址 ",
        correspondenceAddressText: "（如與上址不同）",
        contactNum1: "流動電話",
        contactNum2: "住所電話",
        applicantEmail: "電郵地址",
        reEnterEmail: "請再次輸入電郵地址以作確認",
        residenceText: "在香港居留時間(請按日期先後填寫)",
        residenceFrom: "由",
        residenceTo: "至",
        residenceDuration: "期間(年-月)",
        residenceTotal: "合計",
        automaticCalculation: "自動計算",
        bachelorDegree: "學士學位",
        programmeName: "課程名稱",
        institute: "院校",
        attendanceMode: "上課形式",
        programmeDuration: "修讀年期 (年) (例如: 3)",
        programmeDurationLabel: " (例如: 3)",
        awardYear: "頒發/將獲頒發的日期",
        majorSubject: "主修科目",
        minorSubject: "副修科目",
        masterOfPostGraduateStudies: "碩士/博士學位或深造課程",
        otherSpecify: "請註明",
        teacherTraining: "教師培訓",
        professionalQualifications: "專業及其他資格(例如副學士、高級文憑等)",
        qualifications: "資格",
        issuingAuthorityOrInstitute: "頒發機構/院校名稱",
        levelAttained: "已達到/將達到的程度",
        dateObtained: "獲取/將獲取資格的日期",
        otherInformation: "義務工作(按日期順序列出)",
        nameOfAgency: "機構名稱",
        positionHeld: "職位",
        workFrom: "由",
        workTo: "至",
        candidate: "你是否殘疾人士?",
        natureAndDegree: "如為殘疾人士，請註明殘疾性質及程度",
        labelOne: "請註明在參加考試/面試時，是否需要特別的安排",
        examination: "考試",
        examinationRequired: "如需特別考試安排，請列明有關要求",
        interview: "面試",
        interviewRequired: "如需特別面試安排，請列明有關要求",
        documentNoteList: {
            1: "為了方便進行學歷評審的工作，申請人應在<span class='closing-date'>申請截止日期或之前</span>上載下列證明文件，並盡可能提供所有其他有關學歷證明文件 -",
            2: "1.學士/碩士/博士學位證書及成績單",
            3: "2.教師培訓證書及成績單",
            4: "3.其他(例如: 改名契等)",
        },
        documentNote:
            "備註:<br/>i)  每次上傳最多五(5)個檔案。上傳檔案的總上限為10MB。<br/>ii) 請確保各上傳檔案清晰可讀，檔案格式應為JPEG，PDF，GIF或PNG。<br/>iii) 如有需要，申請人其後或須提交其他證明文件，以便本局評審其學歷資格。<br/>iv) 請不要上傳設有密碼保護的檔案。",
        informationNote:
            "註：政府在遴選時對殘疾人士及其他申請人會一視同仁。申請人如需獲得為殘疾人士而設的聘任相關安排，教育局可能要求提交醫生證明其為殘疾人士。",
        declarationList: {
            1: "本人確認符合職位列明所需的入職要求，並已上載/將會在截止申請日期或之前上載招聘廣告列明所需提交的證明文件。",
            2: "本人明白倘若故意在填寫本申請書時虛報資料或隱瞞重要事實，或未有在申請書內所提供資料已作更改後通知教育局，可令本人喪失獲政府錄用的資格；即使已獲政府錄用，亦可遭終止聘用。",
            3: "本人同意政府可就進行與政府招聘工作及僱用有關的事宜，及為核實上述資料而進行必要的查詢。本人授權所有政府部門及其他組織或機構可就這些查詢，透露任何有關的紀錄及資料（其中包括，在提出聘任前，向本人的現行及／或前僱主索取一份僱主推薦書／工作表現評核報告；向有關當局／機構／醫護人員索取本人的體格檢查報告、醫事委員會報告或診療紀錄，及將有關資料送交其他當局／機構／醫護人員；以及向有關的政府部門／院校／機構查詢本人的學歷／語文／專業資格和索取有關紀錄，及將有關資料送交其他政府部門／當局／機構進行學歷評審）。本人謹此授權香港警務處處長或其代表把所有關於我的犯罪紀錄及詳情發放予有關政府部門／當局／機構。就我的職位申請，我也同意當有需要時，可套取我的指紋以核實我的犯罪紀錄。",
            4: "本人明白並同意，如有需要，上述資料會送交獲授權處理有關資料的政府部門及其他組織或機構，用以進行與政府招聘工作，以及其他與僱用和人力資源管理有關的事宜，例如學歷評審、體格檢查、僱主推薦及操守審查等。",
        },
        declarationNote:
            "註： 請在下列所有方格內加上 “✓” 號，表示你已閱讀，明白及接受此部所列明之所有條件，否則你的申請將不獲處理。",
        agreement: "本人已閱讀、明白及接受上述之條件及細則。",
        bestResultsInCNSubject: "中文科最佳成績",
        secondaryEducationExamination: "(i) 香港中學文憑考試",
        secondaryEducationExaminationofEn: "(i) 香港中學文憑考試 - 英國語文",
        secondaryEducationExaminationofCn: "(i) 香港中學文憑考試- 中國語文",
        advancedLevelExamination: "(ii) 香港高級程度會考",
        advancedLevelExaminationofEn: "(ii) 香港高級程度會考 – 英語運用",
        advancedLevelExaminationofCn:
            "(ii) 香港高級程度會考 - 中國語文、中國語言文學或中國語文及文化",
        cnCulture: "中國語文及文化",
        cnLiterature: "中國語文、中國語言文學",
        CRE: "(iii) 綜合招聘考試 - 中文運用",
        level: "等級",
        testDate: "測試日期",
        selectPlaceHolder: "請選擇一個選項",
        bestResultsInENSubject: "英文科最佳成績",
        CREofEn: "(v) 綜合招聘考試 - 英文運用",
        IELTS: "(iii) 國際英語水平測試 (IELTS) (學術模式)",
        overallBand: "整體分級",
        listeningBand: "聽解分級",
        readingBand: "閱讀分級",
        writingBand: "寫作分級",
        speakingBand: "英語會話分級",
        testDateofEn: "考試日期",
        advancedLevel: "(iv) 普通教育文憑高級程度 - 英國語文",
        nationalSecurityResult: "基本法及香港國安法測試",
        nationalSecurityResultMsg:
            "(《基本法》測試的成績並不等同《基本法及香港國安法》測試的成績）",
        nationalSecurityResultNote:
            "（註：由2023年7月28日起展開招聘的公務員職位，申請人可以參加公務員事務局、教育局或各招聘部門／職系舉辦的《基本法及香港國安法》測試。無論測試是在2023年7月28日之前或之後舉行，及格成績可以互通，用作申請相關公務員職位，以及公帑資助學校或參加幼稚園教育計劃的幼稚園教席。）",
        nationalSecurityResultTitle:
            "你是否曾於下列測試中取得及格成績？ （請選擇適用答案。如你未曾參加以下任何一項測試，請選擇“不適用”。）",
        result: "(a) 基本法及香港國安法測試(學位／專業程度職系) (由公務員事務局或各招聘部門／職系舉辦)",
        nationalSecurityResultLevel:
            "(b) 基本法及香港國安法測試(學位程度) (由教育局舉辦)",
        languageCommission: "國家語言文字工作委員會 – 普通話水平測試",
        grade: "等級",
        AEOorAPSMSupplementary: "英國語文科補充資料",
        englishLanguage: "英國語文",
        LPATEnglish: "(i) 語文能力評核（前稱「教師語文能力評核」）(英國語文) ",
        reading: "閱讀",
        writing: "寫作",
        listening: "聆聽",
        speaking: "口語",
        classroomAssessment: "課堂語言運用",
        levelAttainedofEnglish: "已達到的級別",
        obtainedDate: "獲取/豁免日期",
        AEOSupplementary: "助理教育主任(英國語文)職位補充資料",
        GCEExaminations:
            "(ii) 英國倫敦普通教育文憑考試／英國普通教育文憑考試(普通程度)(海外)（GCE ‘O’ Level Overseas）",
        obtainedDateOfMY: "獲取日期",
        IGCSEForEnglish:
            "(iii) 英國劍橋大學普通教育文憑考試（IGCSE）英文科(作為第一語言／第二語言)",
        instituteMembership: "(iv) 英國語言學會會員資格",
        othersSpecify: "其他，請註明",
        MathSupplementary: "數學科補充資料",
        compulsoryPart: "必修部分",
        calculusStatistics: "延伸部分 - 單元一（微積分與統計）",
        algebraCalculus: "延伸部分 - 單元二（代數與微積分）",
        hkCertificateOfExamination: "(iii) 香港中學會考",
        year2006OrBefore: "2006 年或以前",
        year2007OrBefore: "2007 年或以後",
        PutonghuaSupplementary: "普通話科補充資料",
        LPATPutonghua: "(i) 語文能力評核（前稱「教師語文能力評核」）(普通話)",
        AttainedLevel3: "成績達到「三級」或以上",
        workingExperience:
            "截至目前為止的全部就業詳情（包括以前受僱於政府的資料和兼職資料）（按任職的日期順序列出）",
        schoolName: "學校/機構名稱",
        fullTimeOrPartTime: "全職/兼職",
        natureWork: "工作性質",
        subjectTaught: "任教科目",
        levelTaught: "任教年級",
        periodOfdmy: "期間",
        employmentDuration: "全職工作時間",
        dutiesDescription: "職責說明（例如：課堂教學、擬備試卷等）",
        fullTimeEmployment: "全職工作年數",
        disciplinaryOffence:
            "如你現時或曾在政府任職，在政府任職期間曾否有任何違反紀律的紀錄？",
        disciplinaryOffenceDetails: "如有， 請列明詳情",
        disciplinaryOffenceNote:
            "(註:如申請人曾有違反紀律紀錄，政府不一定因此而不予錄用。)",
        workingExperienceFrom: "由",
        workingExperienceTo: "至",
        postTitle: "請選擇你想申請的職位<span class='danger'>*</span>",
        period: "日期",
        otherInformationTitle: "其他資訊 (可選擇是否填寫)",
        type: "類別",
        validityDate: "有效期",
        creTestDate: "考試日期",
        equivalentLevel2: "等同二級成績",
        bestResultCnMsg:
            "請注意，你並未符合相關職位的語文能力要求(即在綜合招聘考試的中文運用試卷中取得「二級」成績，或具備同等成績)，申請將不獲繼續處理。如欲了解相關職位的語文能力要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        bestResultEnMsg:
            "請注意，你並未符合相關職位的語文能力要求(即在綜合招聘考試的英文運用試卷中取得「二級」成績，或具備同等成績)，申請將不獲繼續處理。如欲了解相關職位的語文能力要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        bestResultEnAndCnMsg:
            "請注意，你並未符合相關職位的語文能力要求(即在綜合招聘考試的中文運用及英文運用試卷中取得「二級」成績，或具備同等成績)，申請將不獲繼續處理。如欲了解相關職位的語文能力要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        notedContinue: "明白及繼續",
        guiltyOffence: "你曾否經香港或香港以外的法庭判定有罪？",
        guiltyOffenceDetails: "如經判定有罪，請列明詳情",
        servingServed: "你是否現時或曾在政府任職?",
        servingServedYesMsg:
            "如你現時或曾在政府任職，你曾否簽署聲明，擁護《中華人民共和國香港特別行政區基本法》，效忠中華人民共和國香港特別行政區（“香港特區”），盡忠職守和對香港特區政府負責？",
        noneOption: "請選擇",
        importantNotes: "本人確認已閱讀並完全理解上述重要須知",
        noted: "明白",
        timeoutNote:
            "註：你的申請將在登入超過2小時及／或系統閒置超過30分鐘後自動關閉。",
        timeoutMsg:
            "你的申請將在{{minutes}}分鐘後自動關閉。請謹記在登出前完成/儲存你的申請。",
        supplementaryInfo: "補充資料",
        guiltyOffenceNote:
            "（註：請參閱《罪犯自新條例》(第297章) (該條例)。請特別留意該條例第4(2)(c)條及附表所載的例外規定。該條例第4(2)(c)條規定，第2(1)及(1A)條給予已自新人士的保障，並不適用於與訂明職位的聘任有關的問題。訂明職位列於該條例附表內，包括“正由或將由薪俸在總薪級表第27薪點或以上的人員出任的職位”。舉例說，如你正申請總薪級表第25至33薪點的職位，因這個職位將由薪俸在總薪級表第27薪點或以上的人員出任，所以第2(1)及(1A)條給予已自新人士的保障並不適用，你必須對曾被判有罪行的所有罪行（如有的話）作出聲明，否則將不獲考慮聘任。如你對申請職位的薪級表有疑問，請向教育局查詢。）",
        servingServedNote:
            "（註： 所有中華人民共和國香港特別行政區政府（“香港特區政府 ”）的公務員及按非公務員聘用條款聘用的政府僱員均須簽署聲明， 擁護 《中華人民共和國香港特別行政區基本法》， 效忠中華人民共和國香港特別行政區 ， 盡忠職守和對香港特區政府負責。）",
        employmentNote: "（註：申請人的相關工作經驗及性質將作進一步審核。）",
        permanentResidentNote:
            "請注意除另有指明外，申請人於<b>獲聘時</b>必須已成為香港特別行政區永久性居民。",
        permanentResidentMsg:
            "（如對香港特別行政區永久性居民身分有任何疑問，可致電入境事務處居留權查詢熱線2824 6111。）",
        previewPDF:
            "如你想打印及/或下載 PDF 格式的申請表，請按下方「預覽 PDF」鍵。",
        LPATEnglishNote:
            "請注意，除另有指明外，你在獲聘時必須在語文能力評核（前稱「教師語文能力評核」）（英國語文）達到「三級」或以上的成績，或已獲豁免符合該項語文能力要求。",
        LPATPutonghuaNote:
            "請注意，除另有指明外，你在獲聘時必須在語文能力評核（前稱「教師語文能力評核」）（普通話）達到「三級」或以上的成績。",
        AEOAandAIG4yearsNote:
            "請注意，你並未符合助理督學(學位)職位的工作經驗要求，申請將不獲繼續處理。你可考慮修改申請書內的資料。如欲了解相關職位的工作經驗要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        SES14yearsNote:
            "請註意，你並未符合申請一級專責教育主任職位的工作經驗要求。你的申請將不能作進一步處理。你可重新修訂申請書內申請職位及/或其他資料。有關申請職位的工作經驗要求，請參閱招聘廣告。如有任何查詢，請在正常辦公時間內致電2892 6686與教育局聘用及人事組聯絡或電郵至 edbappt@edb.gov.hk",
        AEOAandorAIG3yearsNote:
            "請注意，你並未符合相關職位的工作經驗要求，申請將不獲繼續處理。你可考慮修改申請書內的資料。如欲了解相關職位的工作經驗要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        AIG4yearsNote:
            "請注意，你並未符合相關職位的工作經驗要求，申請將不獲繼續處理。你可考慮修改申請書內的資料。如欲了解相關職位的工作經驗要求，請參閱招聘廣告。如有查詢，請在辦公時間內致電2892 6686與教育局聘用及人事組聯絡，或電郵至 edbappt@edb.gov.hk。",
        placeOfBirth: "出生地點",
        postSelectNote: "註：你可在本申請書選擇多個職位。",
        autosuggestGroupText: "請選擇及/或輸入文字",
        professionalMsgForSE:
            "就助理督學(學位)(特殊教育)職位︰請在「專業及其他資格」一欄內述明曾接受的特殊教育相關訓練。",
        workingExperienceMsgForSE:
            "就助理督學(學位)(特殊教育)職位︰請在「職責說明」一欄內闡述在取得學士學位後是否具備四年相關工作經驗，如教育及／或支援有特殊教育需要的學童，及／或具備特殊學校教學經驗，或其他同等經驗。請提供有關細節，包括但不限於任教的學校/服務的機構、職位、任教/服務年級及任教/服務年期。",
        workingExperienceMsgForKindergarten:
            "就助理督學(學位)(幼稚園教育)職位︰請在「職責說明」一欄內闡述在取得學士學位後是否具備四年從事幼兒教育或幼兒工作的相關經驗。請提供有關細節，包括但不限於任教的學校/服務的機構、職位、任教/服務年級及任教/服務年期。",
        workingExperienceMsgForCounselling:
            "就助理督學(學位)(教育輔導、學生輔導及訓育)職位︰請在「職責說明」一欄內闡述在取得學士學位後是否具備四年從事兒童教育、訓育或輔導的相關工作經驗。請提供有關細節，包括但不限於任教的學校/服務的機構、職位、任教/服務年級及任教/服務年期。",
        workingExperienceMsgForCitizenship:
            "就助理督學(學位)(公民與社會發展)職位︰請在「職責說明」一欄內闡述在取得學士學位後是否具備四年相關工作經驗，當中並包括最少三年全面涵蓋中四、中五及中六通識教育學科的教學經驗。請提供有關細節，包括但不限於任教的學校/機構、職位、任教年級及任教年期。",
        specialEducation: "特殊教育",
        nonSpecialEducation: "非特殊教育",
        computerSystemConfiguration: "電腦系統配置",
        computerSystemConfigurationText1:
            "為確保本系統能正確及有效地為你提供服務，我們建議你使用最新版本的<b>微軟Edge、Mozilla Firefox、Safari或Google Chrome瀏覽器</b>，以獲最佳效果。",
        computerSystemConfigurationText2:
            "教育局不會就任何因操作系統及互聯網瀏覽器組合所引致的系統故障及有關職位查詢／申請的錯誤、遺漏、延誤、或錯誤陳述或失實陳述（不論明示或默示的）承擔任何責任。",
        iamsmartContent:
            "你可選擇以「智方便填表通」的個人資料自動填寫網上表格。請點選「智方便填表通」。",
        append: "加行",
        fileUploadMsg: "選擇檔案",
        switchLangContent:
            "轉換語言後，網頁會轉至申請書首頁，已填寫的資料將不會轉移至申請書。",
        switchLangContent2: "請確認是否仍須轉換語言。",
        successfulSubmissionMsg1: "你已成功遞交申請書。",
        successfulSubmissionMsg2: "系統已發送確認電郵至你的電郵地址。",
        servedEDBNote: "你是否現時或曾在教育局任職？",
        servedSchoolNote: "你現時或曾在哪間官立學校/教育局分部及/或組別任職？",
        schoolOrDivision: "學校/分部/組別",
        fromDate: "由",
        toDate: "至",
        englishBestResultsNote:
            "(註：如你申請助理教育主任 / 助理小學學位教師（英國語文），請在下方填寫你的國際英語水平測試（學術模式）成績(如適用)。)",
        englishSupplementaryNote:
            "(註：請在下方填寫語文能力評核成績及/或在第4.3步填寫國際英語水平測試（學術模式）成績。)",
    },
    options: {
        titleOp: {
            Dr: "博士",
            Miss: "小姐",
            Mr: "先生",
            Mrs: "太太",
            Ms: "女士",
        },
        sexCodeOp: {
            M: "男性",
            F: "女性",
        },
        permanentResidentOp: {
            Yes: "是",
            No: "否",
        },
        districtOldOp: {
            CW: "中西區",
            HKE: "東區",
            SOU: "南區",
            I: "離島",
            WCH: "灣仔",
            KC: "九龍城",
            KT: "觀塘",
            SSP: "深水埗",
            WTS: "黃大仙",
            YTM: "油尖旺",
            KWT: "葵青",
            TW: "荃灣",
            YL: "元朗",
            TM: "屯門",
            N: "北區",
            SK: "西貢",
            ST: "沙田",
            TP: "大埔",
        },
        districtOp: {
            中西區: {
                Admiralty: "金鐘",
                Central: "中環",
                "Kennedy Town": "堅尼地城",
                "Mid-levels": "半山",
                "Sheung Wan": "上環",
                "Shek Tong Tsui": "石塘咀",
                "Sai Ying Pun": "西營盤",
                "The Peak": "山頂",
                "West Point": "西環",
            },
            東區: {
                "Braemar Hill": "寶馬山",
                "Chai Wan": "柴灣",
                "Fortress Hill": "炮台山",
                "Heng Fa Chuen": "杏花邨",
                "North Point": "北角",
                "Quarry Bay": "鰂魚涌",
                "Shau Kei Wan": "筲箕灣",
                "Siu Sai Wan": "小西灣",
                "Sai Wan Ho": "西灣河",
                "Tin Hau": "天后",
                "Tai Koo": "太古",
            },
            南區: {
                Aberdeen: "香港仔",
                "Ap Lei Chau": "鴨脷洲",
                "Chung Hom Kok": "舂磡角",
                "Deep Water Bay": "深水灣",
                "Pok Fu Lam": "薄扶林",
                "Repulse Bay": "淺水灣",
                "Shouson Hill": "壽臣山",
                "Shek O": "石澳",
                Stanley: "赤柱",
                "Tai Tam": "大潭",
                "Tin Wan": "田灣",
                "Wong Chuk Hang": "黃竹坑",
                "Wong Nai Chung": "黃泥涌",
            },
            灣仔區: {
                "Causeway Bay": "銅鑼灣",
                "Happy Valley": "跑馬地",
                "So Kon Po": "掃桿埔",
                "Tai Hang": "大坑",
                "Wan Chai": "灣仔",
            },
            九龍城區: {
                "Ho Man Tin": "何文田",
                "Hung Hom": "紅磡",
                "Kowloon City": "九龍城",
                "Kowloon Tong": "九龍塘",
                "Kai Tak": "啟德",
                "Ma Tau Chung": "馬頭涌",
                "Ma Tau Wai": "馬頭圍",
                "To Kwa Wan": "土瓜灣",
                Whampoa: "黃埔",
            },
            觀塘區: {
                "Cha Kwo Ling": "茶果嶺",
                "Kowloon Bay": "九龍灣",
                "Kwun Tong": "觀塘",
                "Lam Tin": "藍田",
                "Lei Yue Mun": "鯉魚門",
                "Ngau Tau Kok": "牛頭角",
                "Sau Mau Ping": "秀茂坪",
                "Yau Tong": "油塘",
            },
            深水埗區: {
                "Cheung Sha Wan": "長沙灣",
                "Lai Chi Kok": "荔枝角",
                "Mei Foo": "美孚",
                "Nam Cheong": "南昌",
                "Stonecutters Island": "昂船洲",
                "Shek Kip Mei": "石硤尾",
                "Sham Shui Po": "深水埗",
                "Tai Kok Tsui": "大角咀",
                "Tai Wo Ping": "大窩坪",
                "Yau Yat Tsuen": "又一村",
            },
            黃大仙區: {
                "Choi Hung": "彩虹",
                "Diamond Hill": "鑽石山",
                "Lok Fu": "樂富",
                "Ngau Chi Wan": "牛池灣",
                "San Po Kong": "新蒲崗",
                "Tsz Wan Shan": "慈雲山",
                "Wang Tau Hom": "橫頭磡",
                "Wong Tai Sin": "黃大仙",
            },
            油尖旺區: {
                "Ferry Point": "渡船角",
                Jordan: "佐敦",
                "Mong Kok": "旺角",
                "Prince Edward": "太子",
                "Tsim Sha Tsui": "尖沙咀",
                "West Kowloon": "西九龍",
                "Yau Ma Tei": "油麻地",
            },
            離島區: {
                "Cheung Chau": "長洲",
                "Cheung Sha Lantau Island": "大嶼山長沙",
                "Chek Lap Kok Lantau Island": "大嶼山赤鱲角",
                "Chi Ma Wan Lantau Island": "大嶼山芝蔴灣",
                "Discovery Bay Lantau Island": "大嶼山愉景灣",
                Disneyland: "迪士尼樂園",
                "Disneyland Resort": "迪士尼度假區",
                "Hei Ling Chau": "喜靈洲",
                "Lantau Island": "大嶼山",
                "Lamma Island": "南丫島",
                "Mui Wo Lantau Island": "大嶼山梅窩",
                "Ngong Ping Lantau Island": "大嶼山昂坪",
                "Peng Chau": "坪洲",
                "Poi Toi Island": "蒲台島",
                "Shek Pik Lantau Island": "大嶼山石壁",
                "Shek Kwu Chau": "石鼓洲",
                "Sha Lo Wan": "沙螺灣",
                "Tai O Lantau Island": "大嶼山大澳",
                "Tong Fuk Lantau Island": "大嶼山塘福",
                "Tung Peng Chau": "東平洲",
                "Tung Chung Lantau Island": "大嶼山東涌",
            },
            葵青區: {
                "Kwai Fong": "葵芳",
                "Kwai Hing": "葵興",
                "Kwai Shing": "葵盛",
                "Kwai Chung": "葵涌",
                "Lai King": "荔景",
                "Shek Lei": "石籬",
                "Tsing Yi": "青衣",
                "Tai Wo Hau": "大窩口",
            },
            北區: {
                "Crooked Island": "吉澳洲",
                Fanling: "粉嶺",
                "Hang Tau": "坑頭",
                "Kat O": "吉澳",
                "Kwu Tung": "古洞",
                "Lo Wu": "羅湖",
                "Luen Wo Hui": "聯和墟",
                "Lung Yeuk Tau": "龍躍頭",
                "Man Kam To": "文錦渡",
                "Muk Wu": "木湖",
                "Ping Che": "坪輋",
                "Sheung Shui": "上水",
                "Sandy Ridge": "沙嶺",
                "Sha Tau Kok": "沙頭角",
                "Shek Wu Hui": "石湖墟",
                "Tsiu Hang": "蕉坑",
                "Ta Kwu Ling": "打鼓嶺",
                "Wong Kong Shan": "黃崗山",
            },
            西貢區: {
                "Clear Water Bay": "清水灣",
                "Fei Ngo Shan": "飛鵝山",
                "Hang Hau Sai Kung": "西貢坑口",
                "Kau Sai Chau": "滘西洲",
                "Lohas Park": "康城",
                "Leung Shuen Wan": "糧船灣",
                "Po Lam": "寶林",
                "Po Lo Che": "菠蘿輋",
                "Pak Shek Wo": "白石窩",
                "Pak Sha Wan": "白沙灣",
                "Pak Tam Chung": "北潭涌",
                "Pik Uk": "壁屋",
                "Sai Kung": "西貢",
                "Sha Kok Mei": "沙角尾",
                "Tiu Keng Leng": "調景嶺",
                "Tseung Kwan O": "將軍澳",
                "Tung Lung Chau": "東龍洲",
                "Tui Min Hoi": "對面海",
            },
            沙田區: {
                "A Kung Kok": "亞公角",
                "Che Kung Miu": "車公廟",
                "Fo Tan Sha Tin": "沙田火炭",
                "Hin Keng": "顯徑",
                "Heng On": "恆安",
                "Kau To Shan": "九肚山",
                "Ma Liu Shui": "馬料水",
                "Ma On Shan": "馬鞍山",
                "Pak Shek Kok": "白石角",
                "Sha Tin": "沙田",
                "Siu Lek Yuen Sha Tin": "沙田小瀝源",
                "Shek Mun": "石門",
                "Sha Tin Wai": "沙田圍",
                "Sui Wo": "穗禾",
                "Tai Wai Sha Tin": "沙田大圍",
                "Wu Kai Sha": "烏溪沙",
            },
            屯門區: {
                "Castle Peak Bay": "青山灣",
                "Fu Tei Tuen Mun": "屯門虎地",
                "Kau Hui": "舊墟",
                "Lung Kwu Tan": "龍鼓灘",
                "Lam Tei Tuen Mun": "屯門藍地",
                "San Hui Tuen Mun": "屯門新墟",
                "Siu Lam Tuen Mun": "屯門小欖",
                "So Kwun Wat": "掃管笏",
                "Tai Lam": "大欖",
                "Tuen Mun": "屯門",
            },
            大埔區: {
                "Cheung Muk Tau": "樟木頭",
                "Kau Lung Hang": "九龍坑",
                "Lam Tsuen Tai Po": "大埔林村",
                "Lam Tsuen Valley": "林村谷",
                "Nam Hang": "南坑",
                "Shap Sze Heung": "十四鄉",
                "Shuen Wan Tai Po": "大埔船灣",
                "Tai Po": "大埔",
                "Tai Wo": "太和",
                "Tap Mun": "塔門",
                "Tai Mei Tuk": "大美督",
                "Tai Po Kau": "大埔滘",
                "Tai Po Market": "大埔墟",
                "Tai Po Tau": "大埔頭",
                "Yuen Chau Tsai": "元洲仔",
            },
            荃灣區: {
                "Lei Muk Shue": "梨木樹",
                "Lo Wai Tsuen Wan": "荃灣老圍",
                "Ma Wan": "馬灣",
                "Sunny Bay": "欣澳",
                "Sham Tseng": "深井",
                "Ting Kau": "汀九",
                "Tsing Lung Tau": "青龍頭",
                "Tsuen Wan": "荃灣",
            },
            元朗區: {
                "Au Tau": "坳頭",
                "Ha Tsuen Yuen Long": "元朗廈村",
                "Hung Shui Kiu": "洪水橋",
                "Kam Tin Yuen Long": "元朗錦田",
                "Lau Fau Shan": "流浮山",
                "Lok Ma Chau": "落馬洲",
                "Long Ping": "朗屏",
                "Ma Tin": "馬田",
                "Pat Heung Yuen Long": "元朗八鄉",
                "Ping Shan Yuen Long": "元朗屏山",
                "San Tin Yuen Long": "元朗新田",
                "Shek Kong Yuen Long": "元朗石崗",
                "Shap Pat Heung": "十八鄉",
                "Tam Mei Yuen Long": "元朗潭尾",
                "Tin Shui Wai": "天水圍",
                "Tai Shu Ha": "大樹下",
                "Tai Sang Wai": "大生圍",
                "Tai Tong Yuen Long": "元朗大棠",
                "Wang Chau": "橫洲",
                "Wang Toi Shan": "橫台山",
                "Yuen Long": "元朗",
            },
        },
        districtEnOp: {
            "Central and Western District": {
                Admiralty: "Admiralty",
                Central: "Central",
                "Kennedy Town": "Kennedy Town",
                "Mid-levels": "Mid-levels",
                "Sheung Wan": "Sheung Wan",
                "Shek Tong Tsui": "Shek Tong Tsui",
                "Sai Ying Pun": "Sai Ying Pun",
                "The Peak": "The Peak",
                "West Point": "West Point",
            },
            "Eastern District": {
                "Braemar Hill": "Braemar Hill",
                "Chai Wan": "Chai Wan",
                "Fortress Hill": "Fortress Hill",
                "Heng Fa Chuen": "Heng Fa Chuen",
                "North Point": "North Point",
                "Quarry Bay": "Quarry Bay",
                "Shau Kei Wan": "Shau Kei Wan",
                "Siu Sai Wan": "Siu Sai Wan",
                "Sai Wan Ho": "Sai Wan Ho",
                "Tin Hau": "Tin Hau",
                "Tai Koo": "Tai Koo",
            },
            "Southern District": {
                Aberdeen: "Aberdeen",
                "Ap Lei Chau": "Ap Lei Chau",
                "Chung Hom Kok": "Chung Hom Kok",
                "Deep Water Bay": "Deep Water Bay",
                "Pok Fu Lam": "Pok Fu Lam",
                "Repulse Bay": "Repulse Bay",
                "Shouson Hill": "Shouson Hill",
                "Shek O": "Shek O",
                Stanley: "Stanley",
                "Tai Tam": "Tai Tam",
                "Tin Wan": "Tin Wan",
                "Wong Chuk Hang": "Wong Chuk Hang",
                "Wong Nai Chung": "Wong Nai Chung",
            },
            "Wan Chai District": {
                "Causeway Bay": "Causeway Bay",
                "Happy Valley": "Happy Valley",
                "So Kon Po": "So Kon Po",
                "Tai Hang": "Tai Hang",
                "Wan Chai": "Wan Chai",
            },
            "Kowloon City District": {
                "Ho Man Tin": "Ho Man Tin",
                "Hung Hom": "Hung Hom",
                "Kowloon City": "Kowloon City",
                "Kowloon Tong": "Kowloon Tong",
                "Kai Tak": "Kai Tak",
                "Ma Tau Chung": "Ma Tau Chung",
                "Ma Tau Wai": "Ma Tau Wai",
                "To Kwa Wan": "To Kwa Wan",
                Whampoa: "Whampoa",
            },
            "Kwun Tong District": {
                "Cha Kwo Ling": "Cha Kwo Ling",
                "Kowloon Bay": "Kowloon Bay",
                "Kwun Tong": "Kwun Tong",
                "Lam Tin": "Lam Tin",
                "Lei Yue Mun": "Lei Yue Mun",
                "Ngau Tau Kok": "Ngau Tau Kok",
                "Sau Mau Ping": "Sau Mau Ping",
                "Yau Tong": "Yau Tong",
            },
            "Sham Shui Po District": {
                "Cheung Sha Wan": "Cheung Sha Wan",
                "Lai Chi Kok": "Lai Chi Kok",
                "Mei Foo": "Mei Foo",
                "Nam Cheong": "Nam Cheong",
                "Stonecutters Island": "Stonecutters Island",
                "Shek Kip Mei": "Shek Kip Mei",
                "Sham Shui Po": "Sham Shui Po",
                "Tai Kok Tsui": "Tai Kok Tsui",
                "Tai Wo Ping": "Tai Wo Ping",
                "Yau Yat Tsuen": "Yau Yat Tsuen",
            },
            "Wong Tai Sin District": {
                "Choi Hung": "Choi Hung",
                "Diamond Hill": "Diamond Hill",
                "Lok Fu": "Lok Fu",
                "Ngau Chi Wan": "Ngau Chi Wan",
                "San Po Kong": "San Po Kong",
                "Tsz Wan Shan": "Tsz Wan Shan",
                "Wang Tau Hom": "Wang Tau Hom",
                "Wong Tai Sin": "Wong Tai Sin",
            },
            "Yau Tsim Mong District": {
                "Ferry Point": "Ferry Point",
                Jordan: "Jordan",
                "Mong Kok": "Mong Kok",
                "Prince Edward": "Prince Edward",
                "Tsim Sha Tsui": "Tsim Sha Tsui",
                "West Kowloon": "West Kowloon",
                "Yau Ma Tei": "Yau Ma Tei",
            },
            "Islands District": {
                "Cheung Chau": "Cheung Chau",
                "Cheung Sha Lantau Island": "Cheung Sha Lantau Island",
                "Chek Lap Kok Lantau Island": "Chek Lap Kok Lantau Island",
                "Chi Ma Wan Lantau Island": "Chi Ma Wan Lantau Island",
                "Discovery Bay Lantau Island": "Discovery Bay Lantau Island",
                Disneyland: "Disneyland",
                "Disneyland Resort": "Disneyland Resort",
                "Hei Ling Chau": "Hei Ling Chau",
                "Lantau Island": "Lantau Island",
                "Lamma Island": "Lamma Island",
                "Mui Wo Lantau Island": "Mui Wo Lantau Island",
                "Ngong Ping Lantau Island": "Ngong Ping Lantau Island",
                "Peng Chau": "Peng Chau",
                "Poi Toi Island": "Poi Toi Island",
                "Shek Pik Lantau Island": "Shek Pik Lantau Island",
                "Shek Kwu Chau": "Shek Kwu Chau",
                "Sha Lo Wan": "Sha Lo Wan",
                "Tai O Lantau Island": "Tai O Lantau Island",
                "Tong Fuk Lantau Island": "Tong Fuk Lantau Island",
                "Tung Peng Chau": "Tung Peng Chau",
                "Tung Chung Lantau Island": "Tung Chung Lantau Island",
            },
            "Kwai Tsing District": {
                "Kwai Fong": "Kwai Fong",
                "Kwai Hing": "Kwai Hing",
                "Kwai Shing": "Kwai Shing",
                "Kwai Chung": "Kwai Chung",
                "Lai King": "Lai King",
                "Shek Lei": "Shek Lei",
                "Tsing Yi": "Tsing Yi",
                "Tai Wo Hau": "Tai Wo Hau",
            },
            "North District": {
                "Crooked Island": "Crooked Island",
                Fanling: "Fanling",
                "Hang Tau": "Hang Tau",
                "Kat O": "Kat O",
                "Kwu Tung": "Kwu Tung",
                "Lo Wu": "Lo Wu",
                "Luen Wo Hui": "Luen Wo Hui",
                "Lung Yeuk Tau": "Lung Yeuk Tau",
                "Man Kam To": "Man Kam To",
                "Muk Wu": "Muk Wu",
                "Ping Che": "Ping Che",
                "Sheung Shui": "Sheung Shui",
                "Sandy Ridge": "Sandy Ridge",
                "Sha Tau Kok": "Sha Tau Kok",
                "Shek Wu Hui": "Shek Wu Hui",
                "Tsiu Hang": "Tsiu Hang",
                "Ta Kwu Ling": "Ta Kwu Ling",
                "Wong Kong Shan": "Wong Kong Shan",
            },
            "Sai Kung District": {
                "Clear Water Bay": "Clear Water Bay",
                "Fei Ngo Shan": "Fei Ngo Shan",
                "Hang Hau Sai Kung": "Hang Hau Sai Kung",
                "Kau Sai Chau": "Kau Sai Chau",
                "Lohas Park": "Lohas Park",
                "Leung Shuen Wan": "Leung Shuen Wan",
                "Po Lam": "Po Lam",
                "Po Lo Che": "Po Lo Che",
                "Pak Shek Wo": "Pak Shek Wo",
                "Pak Sha Wan": "Pak Sha Wan",
                "Pak Tam Chung": "Pak Tam Chung",
                "Pik Uk": "Pik Uk",
                "Sai Kung": "Sai Kung",
                "Sha Kok Mei": "Sha Kok Mei",
                "Tiu Keng Leng": "Tiu Keng Leng",
                "Tseung Kwan O": "Tseung Kwan O",
                "Tung Lung Chau": "Tung Lung Chau",
                "Tui Min Hoi": "Tui Min Hoi",
            },
            "Sha Tin District": {
                "A Kung Kok": "A Kung Kok",
                "Che Kung Miu": "Che Kung Miu",
                "Fo Tan Sha Tin": "Fo Tan Sha Tin",
                "Hin Keng": "Hin Keng",
                "Heng On": "Heng On",
                "Kau To Shan": "Kau To Shan",
                "Ma Liu Shui": "Ma Liu Shui",
                "Ma On Shan": "Ma On Shan",
                "Pak Shek Kok": "Pak Shek Kok",
                "Sha Tin": "Sha Tin",
                "Siu Lek Yuen Sha Tin": "Siu Lek Yuen Sha Tin",
                "Shek Mun": "Shek Mun",
                "Sha Tin Wai": "Sha Tin Wai",
                "Sui Wo": "Sui Wo",
                "Tai Wai Sha Tin": "Tai Wai Sha Tin",
                "Wu Kai Sha": "Wu Kai Sha",
            },
            "Tuen Mun District": {
                "Castle Peak Bay": "Castle Peak Bay",
                "Fu Tei Tuen Mun": "Fu Tei Tuen Mun",
                "Kau Hui": "Kau Hui",
                "Lung Kwu Tan": "Lung Kwu Tan",
                "Lam Tei Tuen Mun": "Lam Tei Tuen Mun",
                "San Hui Tuen Mun": "San Hui Tuen Mun",
                "Siu Lam Tuen Mun": "Siu Lam Tuen Mun",
                "So Kwun Wat": "So Kwun Wat",
                "Tai Lam": "Tai Lam",
                "Tuen Mun": "Tuen Mun",
            },
            "Tai Po District": {
                "Cheung Muk Tau": "Cheung Muk Tau",
                "Kau Lung Hang": "Kau Lung Hang",
                "Lam Tsuen Tai Po": "Lam Tsuen Tai Po",
                "Lam Tsuen Valley": "Lam Tsuen Valley",
                "Nam Hang": "Nam Hang",
                "Shap Sze Heung": "Shap Sze Heung",
                "Shuen Wan Tai Po": "Shuen Wan Tai Po",
                "Tai Po": "Tai Po",
                "Tai Wo": "Tai Wo",
                "Tap Mun": "Tap Mun",
                "Tai Mei Tuk": "Tai Mei Tuk",
                "Tai Po Kau": "Tai Po Kau",
                "Tai Po Market": "Tai Po Market",
                "Tai Po Tau": "Tai Po Tau",
                "Yuen Chau Tsai": "Yuen Chau Tsai",
            },
            "Tsuen Wan District": {
                "Lei Muk Shue": "Lei Muk Shue",
                "Lo Wai Tsuen Wan": "Lo Wai Tsuen Wan",
                "Ma Wan": "Ma Wan",
                "Sunny Bay": "Sunny Bay",
                "Sham Tseng": "Sham Tseng",
                "Ting Kau": "Ting Kau",
                "Tsing Lung Tau": "Tsing Lung Tau",
                "Tsuen Wan": "Tsuen Wan",
            },
            "Yuen Long District": {
                "Au Tau": "Au Tau",
                "Ha Tsuen Yuen Long": "Ha Tsuen Yuen Long",
                "Hung Shui Kiu": "Hung Shui Kiu",
                "Kam Tin Yuen Long": "Kam Tin Yuen Long",
                "Lau Fau Shan": "Lau Fau Shan",
                "Lok Ma Chau": "Lok Ma Chau",
                "Long Ping": "Long Ping",
                "Ma Tin": "Ma Tin",
                "Pat Heung Yuen Long": "Pat Heung Yuen Long",
                "Ping Shan Yuen Long": "Ping Shan Yuen Long",
                "San Tin Yuen Long": "San Tin Yuen Long",
                "Shek Kong Yuen Long": "Shek Kong Yuen Long",
                "Shap Pat Heung": "Shap Pat Heung",
                "Tam Mei Yuen Long": "Tam Mei Yuen Long",
                "Tin Shui Wai": "Tin Shui Wai",
                "Tai Shu Ha": "Tai Shu Ha",
                "Tai Sang Wai": "Tai Sang Wai",
                "Tai Tong Yuen Long": "Tai Tong Yuen Long",
                "Wang Chau": "Wang Chau",
                "Wang Toi Shan": "Wang Toi Shan",
                "Yuen Long": "Yuen Long",
            },
        },
        countryOp: {
            中國: {
                "HK-CN": "香港",
                Mainland: "內地",
                Macao: "澳門",
                Taiwan: "台灣",
            },
            其他: {
                Afghanistan: "阿富汗",
                "Aland-Islands": "奧蘭群島",
                Albania: "阿爾巴尼亞",
                Algeria: "阿爾及利亞",
                "American-Siamoa": "美屬薩摩亞",
                Andorra: "安道爾",
                Angola: "安哥拉",
                Anguilla: "安圭拉",
                Antarctica: "南極洲",
                "Antigua-Barbuda": "安地卡巴布達",
                Argentina: "阿根廷",
                Armenia: "亞美尼亞",
                Aruba: "阿魯巴",
                Australia: "澳大利亞",
                Austria: "奧地利",
                Azerbaijan: "亞塞拜然",
                Bahamas: "巴哈馬",
                Bahrain: "巴林",
                Bangladesh: "孟加拉",
                Barbados: "巴貝多",
                Belarus: "白俄羅斯",
                Belgium: "比利時",
                Belize: "貝里斯",
                Benin: "貝南",
                Bermuda: "百慕達",
                Bhutan: "不丹",
                Bolivia: "玻利維亞",
                "Bosnia-Herzegovina": "波士尼亞赫塞哥維納",
                Botswana: "波札那",
                "Bouvet-Island": "波維特島",
                Brazil: "巴西",
                "British-Indian-Ocean-Territory": "英屬印度洋地區",
                "Brunei-Darussalam": "汶萊",
                Bulgaria: "保加利亞",
                "Burkina-Faso": "布吉納法索",
                Burundi: "蒲隆地",
                Cambodia: "柬埔寨",
                Cameroon: "喀麥隆",
                Canada: "加拿大",
                "Cape-Verde": "維德角",
                "Cayman-Islands": "開曼群島",
                "Central-African-Republic": "中非共和國",
                Chad: "查德",
                Chile: "智利",
                "Christmas-Island": "聖誕島",
                "Cocos(Keeling)-Islands": "可可斯群島",
                Colombia: "哥倫比亞",
                Comoros: "葛摩",
                Congo: "剛果",
                "Cook-Islands": "庫克群島",
                "Costa-Rica": "哥斯大黎加",
                "Cote-D'Ivoire": "象牙海岸",
                Croatia: "克羅埃西亞",
                Cuba: "古巴",
                Cyprus: "塞普勒斯",
                "Czech-Republic": "捷克",
                "Democratic-People's-Republic-of-Korea": "北韓",
                Denmark: "丹麥",
                Djibouti: "吉布地",
                Dominica: "多米尼克",
                "Dominican-Republic": "多明尼加",
                Ecuador: "厄瓜多",
                Egypt: "埃及",
                El: "薩爾瓦多",
                Equatorial: "赤道幾內亞",
                Eritrea: "厄利垂亞",
                Estonia: "愛沙尼亞",
                Ethiopia: "衣索比亞",
                "Falkland-Islands": "福克蘭群島",
                "Faroe-Islands": "法羅群島",
                "Federated-States-of-Micronesia": "密克羅尼西亞聯邦",
                Fiji: "斐濟",
                Finland: "芬蘭",
                France: "法國",
                "French-Guiana": "法屬圭亞那",
                "French-Polynesia": "法屬玻里尼西亞",
                "French-Southern-Territories": "法屬南部屬地",
                Gabon: "加彭",
                Gambia: "甘比亞",
                Georgia: "喬治亞",
                Germany: "德國",
                Ghana: "迦納",
                Gibraltar: "直布羅陀",
                Greece: "希臘",
                Greenland: "格陵蘭",
                Grenada: "格瑞那達",
                Guadeloupe: "哥德洛普",
                Guam: "關島",
                Guatemala: "瓜地馬拉",
                Guernsey: "根息",
                Guinea: "幾內亞",
                "Guinea-Bissau": "幾內亞比索",
                Guyana: "蓋亞那",
                Haiti: "海地",
                "Heard-Island-and-Mcdonald-Islands": "赫德麥當奴群島",
                "Holy-See": "教廷(梵蒂岡)",
                Honduras: "宏都拉斯",
                Hungary: "匈牙利",
                Iceland: "冰島",
                India: "印度",
                Indonesia: "印尼",
                Iraq: "伊拉克",
                Ireland: "愛爾蘭",
                "Islamic-Republic": "伊朗",
                "Isle-of-Man": "曼島",
                Israel: "以色列",
                Italy: "義大利",
                Jamaica: "牙買加",
                Japan: "日本",
                Jersey: "澤西",
                Jordan: "約旦",
                Kazakhstan: "哈薩克",
                Kenya: "肯亞",
                Kiribati: "吉里巴斯",
                Kuwait: "科威特",
                Kyrgyzstan: "吉爾吉斯",
                Laos: "寮國",
                Latvia: "拉脫維亞",
                Lebanon: "黎巴嫩",
                Lesotho: "賴索托",
                Liberia: "賴比瑞亞",
                Libya: "利比亞",
                Liechtenstein: "列支敦斯登",
                Lithuania: "立陶宛",
                Luxembourg: "盧森堡",
                Madagascar: "馬達加斯加",
                Malawi: "馬拉威",
                Malaysia: "馬來西亞",
                Maldives: "馬爾地夫",
                Mali: "馬利",
                Malta: "馬爾他",
                "Marshall-Islands": "馬紹爾群島",
                Martinique: "馬丁尼克",
                Mauritania: "茅利塔尼亞",
                Mauritius: "模里西斯",
                Mayotte: "美亞特",
                Mexico: "墨西哥",
                Monaco: "摩納哥",
                Mongolia: "蒙古",
                Montenegro: "蒙特內哥羅",
                Montserrat: "蒙特色拉",
                Morocco: "摩洛哥",
                Mozambique: "莫三比克",
                Myanmar: "緬甸",
                Namibia: "納米比亞",
                Nauru: "諾魯",
                Nepal: "尼泊爾",
                Netherlands: "荷蘭",
                "Netherlands-Antilles": "荷屬安地列斯",
                "New-Caledonia": "新喀里多尼亞",
                "New-Zealand": "紐西蘭",
                Nicaragua: "尼加拉瓜",
                Niger: "尼日",
                Nigeria: "奈及利亞",
                Niue: "紐埃",
                "Norfolk-Island": "諾福克島",
                "Northern-Mariana-Islands": "北馬里安納群島",
                Norway: "挪威",
                Oman: "阿曼",
                Pakistan: "巴基斯坦",
                Palau: "帛琉",
                Palestinian: "巴勒斯坦",
                Panama: "巴拿馬",
                "Papua-New-Guinea": "巴布亞紐幾內亞",
                Paraguay: "巴拉圭",
                Peru: "秘魯",
                Philippines: "菲律賓",
                Pitcairn: "皮特康",
                Poland: "波蘭",
                Portugal: "葡萄牙",
                "Puerto-Rico": "波多黎各",
                Qatar: "卡達",
                "Republic-of-Korea": "南韓",
                Macedonia: "馬其頓",
                Moldova: "摩爾多瓦",
                Reunion: "留尼旺",
                Romania: "羅馬尼亞",
                Russian: "俄羅斯",
                Rwanda: "盧安達",
                "Saint-Helena": "聖赫勒拿",
                "Saint-Kitts-Nevis": "聖克里斯多福",
                "Saint-Lucia": "聖露西亞",
                "Saint-Pierre-Miquelon": "聖皮耶密克隆",
                "Saint-Vincent-Grenadines": "聖文森",
                Samoa: "薩摩亞",
                "San-Marino": "聖馬利諾",
                "Sao-Tome-Principe": "聖多美普林西比",
                "Saudi-Arabia": "沙烏地阿拉伯",
                Senegal: "塞內加爾",
                Serbia: "塞爾維亞",
                Seychelles: "塞席爾",
                "Sierra-Leone": "獅子山",
                Singapore: "新加坡",
                Slovakia: "斯洛伐克",
                Slovenia: "斯洛維尼亞",
                "Solomon-Islands": "索羅門群島",
                Somalia: "索馬利亞",
                "South-Africa": "南非",
                "South-Georgia-South-Sandwich-Islands": "南喬治亞南桑威奇群島",
                Spain: "西班牙",
                "Sri-Lanka": "斯里蘭卡",
                Sudan: "蘇丹",
                Suriname: "蘇利南",
                "Svalbard-Jan-Mayen": "斯瓦爾巴尖棉",
                Swaziland: "史瓦濟蘭",
                Sweden: "瑞典",
                Switzerland: "瑞士",
                "Syrian-Arab-Republic": "敘利亞",
                Tajikistan: "塔吉克",
                Tanzania: "坦尚尼亞",
                Thailand: "泰國",
                "The-Democratic-Republic-Congo": "剛果民主共和國",
                "Timor-Leste": "東帝汶",
                Togo: "多哥",
                Tokelau: "托克勞",
                Tonga: "東加",
                "Trinidad-Tobago": "千里達托貝哥",
                Tunisia: "突尼西亞",
                Turkey: "土耳其",
                Turkmenistan: "土庫曼",
                "Turks-Caicos-Islands": "托克斯寇克斯群島",
                Tuvalu: "吐瓦魯",
                Uganda: "烏干達",
                Ukraine: "烏克蘭",
                "United-Arab-Emirates": "阿拉伯聯合大公國",
                "United-Kingdom": "英國",
                "United-States": "美國",
                "United-States-Minor-Outlying-Islands": "美屬邊疆群島",
                Uruguay: "烏拉圭",
                Uzbekistan: "烏茲別克",
                Vanuatu: "萬那杜",
                Venezuela: "委內瑞拉",
                "Viet-Nam": "越南",
                "Virgin-Islands-British": "英屬維爾京群島",
                "Virgin-Islands-U.S": "美屬維京群島",
                "Wallis-Futuna": "華里斯福他納",
                "Western-Sahara": "西撒哈拉",
                Yemen: "葉門",
                Zambia: "尚比亞",
                Zimbabwe: "辛巴威",
            },
        },
        instituteOp: {
            "Chu-Hai-College": "香港珠海學院",
            "City-University": "香港城市大學",
            "Baptist-University": "香港浸會大學",
            "Metropolitan-University": "香港都會大學",
            "Shue-Yan-University": "香港樹仁大學",
            "Lingnan-University": "嶺南大學",
            "Tung-Wah-College": "東華學院",
            "Chinese-University": "香港中文大學",
            "Education-University": "香港教育大學",
            "Hang-Seng-University": "香港恒生大學",
            Academy: "香港演藝學院",
            "Polytechnic-University": "香港理工大學",
            "Science-Technology": "香港科技大學",
            University: "香港大學",
            Others: "其他",
        },
        programmeNameOp: {
            postgraduateDiplomaEducation: "學位教師教育文憑",
            postgraduateCertificateEducation: "學位教師教育證書",
            postgraduateDiplomaEducationPrimary: "學位教師教育文憑(小學)",
            postgraduateDiplomaEducationSecondary: "學位教師教育文憑(中學)",
            postgraduateCertificateEducationPrimary: "學位教師教育證書(小學)",
            postgraduateCertificateEducationSecondary: "學位教師教育證書(中學)",
            diplomaEducation: "教育文憑",
            certificatePrimaryEducation: "小學教育證書",
            certificateSecondaryEducation: "中學教育證書",
            certificateEducation: "教育證書",
            teacherCertificate: "教師證書",
            serviceCoursePrimary: "在職小學教師訓練課程",
            serviceCourseSecondary: "在職中學教師訓練課程",
            certificateEarlyChildhoodEducation: "幼兒教育證書(中文)",
            others: "其他",
        },
        secondaryEducationExaminationOp: {
            "05**": "5**",
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
        },
        advancedLevelExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            F: "F",
            U: "U",
        },
        GCEExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            U: "U",
        },
        CRELevelOp: {
            level2: "第2級",
            level1: "第1級",
            fail: "不及格",
        },
        attendanceModeOp: {
            fullTime: "全日制",
            partTime: "兼讀制",
            distanceLearning: "遙距學習",
        },
        bandOp: {
            "9.0": "9.0",
            8.5: "8.5",
            "8.0": "8.0",
            7.5: "7.5",
            "7.0": "7.0",
            6.5: "6.5",
            "6.0": "6.0",
            5.5: "5.5",
            "5.0": "5.0",
            4.5: "4.5",
            "4.0": "4.0",
            3.5: "3.5",
            "3.0": "3.0",
            2.5: "2.5",
            "2.0": "2.0",
            1.5: "1.5",
            "1.0": "1.0",
            0.5: "0.5",
            "00": "0",
        },
        advancedLevelOp: {
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
            unclassified: "不予評級",
        },
        languageCommissionOp: {
            pass: "及格",
            fail: "不及格 / 未曾參加測試",
        },
        attainedOp: {
            attained: "達到",
            notAttained: "未能達到",
            exempted: "豁免",
        },
        putonghuaAttainedOp: {
            attained: "達到",
            notAttained: "未能達到",
        },
        fullTimeOrPartTimeOp: {
            fullTime: "全職",
            partTime: "兼職",
        },
        teachingOp: {
            teaching: "教學",
            nonTeaching: "非教學",
        },
        subjectOp: [
            "生物",
            "企業、會計與財務概論",
            "化學",
            "中國歷史",
            "中國語文",
            "中國文學",
            "公民與社會發展/通識教育",
            "設計與應用科技",
            "經濟",
            "英國語文",
            "英國文學",
            "倫理與宗教",
            "常識",
            "地理",
            "健康管理與社會關懷",
            "歷史",
            "資訊及通訊科技",
            "數學",
            "音樂",
            "體育",
            "物理",
            "普通話",
            "科學",
            "科技與生活",
            "科技教育",
            "旅遊與款待",
            "視覺藝術",
        ],
        levelOp: [
            "中七",
            "中六",
            "中五",
            "中四",
            "中三",
            "中二",
            "中一",
            "小六",
            "小五",
            "小四",
            "小三",
            "小二",
            "小一",
            "幼稚園高班",
            "幼稚園低班",
            "幼兒班",
        ],
        nationalSecurityResultLevelOp: {
            yes: "是",
            no: "否",
            na: "不適用",
        },
    },
    errorMsg: {
        reEnterEmail: "再次輸入的電郵地址應與電郵地址相同",
        duplicatePost:
            "此電郵地址已用作申請此職位，請選擇其他職位。如欲更改已提交的申請資料，請在教育局電子表格遞交系統主頁選擇「表格查詢」。",
        atLeastOnePost: "請選擇至少一個職位",
        atLeastOneSubject: "請選擇至少一個科目",
        duplicateHkid:
            "你輸入的身份證號碼已用作申請此職位，請返回上一頁選擇其他職位。如欲更改已提交的申請資料，請在教育局電子表格遞交系統主頁選擇「表格查詢」。",
        duplicatePassport:
            "你輸入的護照/旅行證件號碼已用作申請此職位，請返回上一頁選擇其他職位。如欲更改已提交的申請資料，請在教育局電子表格遞交系統主頁選擇「表格查詢」。",
        duplicateDeadline: "如欲申請此職位，請提交另一份申請書。",
        editPost: "如欲申請其他職位，請提交另一份申請書。",
        CREMustBeLevel2: "綜合招聘考試 - 中文運用必須達到第二級",
        CREofEnMustBeLevel2: "綜合招聘考試 - 英文運用必須達到第二級",
        postAppliedFor: "請選擇你想申請的職位。",
        issuingAuthority: "請填寫發證機關",
        permanentResident: "請選擇您是否為香港特別行政區的永久性居民",
        residentialAddress: "請填寫住址",
        residentialAddressRoom: "請填寫單位/室",
        residentialAddressFloor: "請填寫樓層",
        residentialAddressBlock: "請填寫座/大廈",
        residentialAddressEstate: "請填寫屋邨",
        residentialAddressRoad: "請填寫道/街",
        residentialAddressDistrict: "請填寫分區",
        residentialAddressCountry: "請選擇國家/地區",
        correspondenceAddressDistrict: "請選擇分區",
        tel1: "請填寫流動電話",
        chineseNameCode: "請填寫中文姓名電碼",
        institute: "請選擇院校",
        instituteOther: "請填寫指定部分",
        attendanceMode: "請選擇上課形式",
        programmeDuration: "請填寫修讀年期",
        awardYear: "請選擇頒發/將獲頒發的日期",
        majorSubject: "請填寫主修科目",
        minorSubject: "請填寫副修科目",
        programmeName: "請填寫課程名稱",
        programmeSelectName: "請選擇課程名稱",
        programmeNameOther: "請填寫指定部分",
        institute1: "請選擇頒發機構/院校名稱",
        levelAttained: "請填寫已達到/將達到的程度",
        dateObtained: "請選擇獲取/將獲取資格的日期",
        secondaryEducationExamination: "請選擇香港中學文憑考試的最佳成績",
        cnCulture: "請選擇中國語文及文化的最佳成績",
        cnLiterature: "請選擇中國語文、中國語言文學的最佳成績",
        creLevel: "請選擇綜合招聘考試（CRE）-中文運用的最佳成績",
        creTestDate: "請選擇考試日期",
        secondaryEducationExaminationofEn: "請選擇香港中學文憑考試的最佳成績",
        enCulture: "請選擇香港高級程度會考的最佳成績",
        enCRELevel: "請選擇綜合招聘考試（CRE）-英語運用的最佳成績",
        enCRETestDate: "請選擇測試日期",
        overallBand: "請選擇整體分級結果",
        listeningBand: "請選擇聽解分級結果",
        readingBand: "請選擇閱讀分級的結果",
        writingBand: "請選擇寫作分級的結果",
        speakingBand: "請選擇英語會話分級的結果",
        enIELTSestDate: "請選擇測試日期",
        advancedLevel: "請選擇普通教育文憑高級程度的結果",
        subjectTaughtOther: "請填寫指定部分",
        levelTaughtOther: "請填寫指定部分",
        disciplinaryOffenceDetails: "請填寫在政府任職期間違反紀律的詳情",
        guiltyOffenceDetails: "請填寫判定有罪詳情",
        natureAndDegree: "請註明殘疾性質及程度",
        examinationRequired: "請列明考試特別安排的有關要求",
        interviewRequired: "請列明面試特別安排的有關要求",
        schoolName: "請填寫學校/機構名稱",
        fullTimeOrPartTime: "請選擇全職/兼職",
        positionHeld: "請填寫職位",
        natureWork: "請選擇工作性質",
        subjectTaught: "請選擇及/或填寫任教科目",
        levelTaught: "請選擇及/或填寫任教年級",
        dutiesDescription: "請填寫職責說明",
        form: "請選擇日期",
        to: "請選擇日期",
        ServiceTo: "有效時間結束應該晚於有效時間開始",
        submitTimeout: "已超時！請在進入form101後兩小時內完成提交！",
        submitFail: "提交失敗",
        duplicatesSubject: "同一科目於同一申請時段不可同時刊登。",
        workingExperienceMinimumYears:
            "請注意，你須符合所申請職位在取得學士學位所需的工作經驗要求。",
        differentJob:
            "“{{differentJob}}”職位處於“發布”狀態，並且內容有改動，請確認是否保存？",
        duration: "請填写日期",
        workingExperienceInputNullData: "请填写工作經驗",
        requiredWithName: "請填寫{{fieldName}}",
        requiredWithSelect: "請選擇{{fieldName}}",
        atLeastOne: "請填寫以上其中一項",
        atLeastOneOfItems: "請填寫(ii) / (iii)其中一項",
        numericOnly: "僅限數字",
        maxDigits: "最多 {{digits}} 位數字",
        enIELTSestDateMinDate: "考試日期要在{{startDate}}至{{endDate}}才有效",
        enIELTSestDateMinDateNew:
            "IELTS考試成績(兩年有效期)必須在職位接受申請期內任何一日均為有效。",
        leastOneQualification: "請在下面至少填寫一項資格。",
        leastOneResultCn: "請在下面輸入至少一個中文科目的成績。",
        leastOneResultEn: "請在下面輸入至少一個英文科目的成績。",
        importantNotes: "請在方格內加上“√”號，然後按「繼續」鍵。",
        engSurnameRequired: "請填寫姓氏",
        engSurnameValid: "請輸入一個有效的姓氏",
        englishOtherNameRequired: "請填寫名字",
        englishOtherNameValid: "請輸入有效的名字",
        hkidOrPassport: "請填寫香港身份證號碼或護照/旅行證件號碼",
        passportValid: "請輸入有效的護照/旅行證件號碼",
        hkidValid: "請輸入有效的香港身份證號碼",
        requiredAgreement: "請在方格內加上“√”號以確認接受相關條款。",
        nationalSecurityResult: "請選擇適用答案",
        workFrom: "請選擇開始的日期",
        workTo: "請選擇結束的日期",
        grade: "請輸入等級",
        obtainedDateOfMY: "請選擇有效期",
        maxTextLength: "不可超過{{max}}個字符",
        gceExaminationsLevel: "請輸入已達到的級別",
        igcseForEnglishLevel: "請輸入已達到的級別",
        instituteMembershipLevel: "請輸入類別",
        schoolOrDivision: "請填寫學校/分部/分組",
        fromDate: "請選擇起始日期",
        toDate: "請選擇結束日期",
        selectDate: "請選擇日期",
        selectoPtion: "請選擇一個選項",
        duplicatePublishJob:
            "“{{duplicatePublishJob}}”職位已存在“發布”狀態，請勿重複發布相同職位。",
    },
    editDialog: {
        title: "通知",
        note: "你的申請表已更新。",
        msg: "請注意，你還未完成及確認在申請書所作的更改。如仍需更改申請資料，請在完成修改後前往最後確認頁面按「提交」按鈕。",
    },
};

export default Form101TC;
